module.exports = __webpack_public_path__ + "static/img/jsgj.8bb3501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jsgj.png
// module id = bYlX
// module chunks = 1